import partnerVisibleNames from "~/resources/partnerVisibleNames.json";

export const usePartnerDisplayName = (partnerCode?: string | null, fallback = "Hamara Mall") => {
  if (!partnerCode) {
    return fallback;
  }

  const normalizedCode = partnerCode.toLowerCase();
  return partnerVisibleNames[normalizedCode as keyof typeof partnerVisibleNames] || fallback;
};
